import { render, staticRenderFns } from "./ques53.vue?vue&type=template&id=7ab155f2&scoped=true"
import script from "./ques53.vue?vue&type=script&lang=js"
export * from "./ques53.vue?vue&type=script&lang=js"
import style0 from "./ques53.vue?vue&type=style&index=0&id=7ab155f2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ab155f2",
  null
  
)

export default component.exports